import apiClient from "./client";
import { isValidStaticWebUsername } from "../config/staticWebUsername";

export async function listDmThreads() {
  return apiClient.get("/messages/threads");
}

export async function getDmThread(threadId) {
  return apiClient.get(`/messages/threads/${threadId}`);
}

export async function searchDmRecipients(query) {
  const trimmed = String(query || "").trim();
  if (!trimmed) return { success: true, users: [] };
  return apiClient.get(`/messages/recipients/suggest?q=${encodeURIComponent(trimmed)}`);
}

export async function startDmThread(recipient, body) {
  if (typeof recipient === "string" && !isValidStaticWebUsername(recipient)) {
    throw new Error("Invalid web username");
  }
  const payload =
    typeof recipient === "string"
      ? { recipientStaticWebUsername: recipient, body }
      : { ...recipient, body };
  return apiClient.post("/messages/threads", payload);
}

export async function replyDmThread(threadId, body) {
  return apiClient.post(`/messages/threads/${threadId}/messages`, { body });
}

export async function reportDmMessage(messageId, reason) {
  return apiClient.post("/messages/reports", { messageId, reason });
}

export async function blockPlayer(blockedPlayerId) {
  return apiClient.post("/messages/blocks", { blockedPlayerId });
}

export async function unblockPlayer(blockedPlayerId) {
  return apiClient.delete(`/messages/blocks/${encodeURIComponent(blockedPlayerId)}`);
}
